import React from 'react'
import {  VideoCameraOutlined } from "@ant-design/icons";
import TicketSummary from './TicketSummary'
import TicketList from './ticketList'
import { Divider, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'
import MotionIconButton from '../../components/icons/MotionIcon';
import BoldPlusIcon from '../../components/icons/BoldPlusIcon';
const { Title, Text } = Typography;

const SupportSystem = () => {
  return (
    <div>
      <div className="w-full justify-between flex ">
        <Title level={3} className="text-gray-900">Support Dashboard</Title>
        <div className="flex justify-end gap-3">
            <Link to="schedule_meeting" >
              <MotionIconButton  tooltip="Schedule meeting"  icon={<VideoCameraOutlined />} onClick={() => { }} />
            </Link>
            <Link to="create_ticket" >
              <MotionIconButton  tooltip="Add  Ticket"  icon={<BoldPlusIcon />}  onClick={()=>{}} />
            </Link>
        </div>
      </div>
      <Divider />
      <Space direction="vertical" size="large" className="w-full">
        <TicketSummary />
        <TicketList />
      </Space>
    </div>
  )
}
export default SupportSystem